<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { Place } from '@/api'
import moment from 'moment'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Ukryty tytuł',
              modelPath: [this, 'form', 'is_title_hidden']
            }),
            new fields.Input({
              label: 'Tytuł',
              required: true,
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.Switch({
              label: 'Ręczne ustawienie',
              modelPath: [this, 'form', 'fill_in_by_hand'],
              help: 'Domyślnie daty automatycznie pobiorą się z wydarzenia.'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              condition: !!this.form.fill_in_by_hand,
              items: this.form.items.map((item, i) => ({
                headerLabel: moment(item.date).format('YYYY-MM-DD'),
                fields: [
                  new fields.ForeignKey({
                    service: Place,
                    label: 'Miejsce',
                    modelPath: [this, 'form', 'items', i, 'place'],
                    labelField: 'name_pl'
                  }),
                  new fields.Date({
                    label: 'Data',
                    modelPath: [this, 'form', 'items', i, 'date'],
                    format: 'yyyy-MM-dd',
                    valueFormat: 'yyyy-MM-dd',
                    type: 'date',
                    required: true
                  }),
                  new fields.WYSIWYG({
                    label: 'Godzina',
                    modelPath: [this, 'form', 'items', i, 'time'],
                    multilingual: true
                  }),
                  new fields.Input({
                    label: 'Cena biletu',
                    modelPath: [this, 'form', 'items', i, 'ticket_price'],
                    multilingual: true
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
